export default __webpack_public_path__ + "static/media/service-1.1a5c3426.jpg";